class JsCollapsible {
  constructor(domElement) {
    this.root = domElement;
    this.list = this.root.querySelector('.js-collapsible-list');
    this.fullListItems = this.root.querySelectorAll('.js-collapsible-list .js-collapsible-item');
    this.trigger = this.root.querySelector('.js-collapsible-trigger');
    this.triggerContainer = this.root.querySelector('.js-collapsible-trigger-container');
    this.header = document.querySelector('.site-header');
    this.limits = {
      mobile: parseInt(this.root.dataset.collapsibleMobile),
      tablet: parseInt(this.root.dataset.collapsibleTablet),
      medium: parseInt(this.root.dataset.collapsibleMedium),
      desktop: parseInt(this.root.dataset.collapsibleDesktop),
    };

    this.isMobileSlider = this.root.dataset.collapsibleMobileType === "slider";
    this.slider = this.root.querySelector('.js-collapsible-slider');
    this.swiperSlider = null;

    this._registerResize();
    this._registerToggleItems();
    this._update();
  }

  _registerResize() {
    window.addEventListener('resize', ()=> {
      this._update();
    });
  }

  _update() {
    if(this.slider && this.isMobileSlider) {
      const sliderWrapper = this.slider.querySelector('.swiper-wrapper');
      if (window.innerWidth < 720 && !this.swiperSlider) {
        //wrap to slider
        this.slider.style.display = 'block';
        this.fullListItems.forEach((item,index) => {
          if(index < this.limits.mobile) {
            const newSlide = document.createElement('div');
            newSlide.classList.add('swiper-slide');
            item.style.display = 'block';
            newSlide.append(item);

            sliderWrapper.append(newSlide);
          }
        });
        //init slider
        this.swiperSlider = new Swiper(this.slider, {
          slidesPerView: parseInt(this.root.dataset.collapsibleMobileSlides || 1),
          spaceBetween: 20,
          navigation: {
            prevEl: this.slider.querySelector('.swiper-prev'),
            nextEl: this.slider.querySelector('.swiper-next'),
            enabled: true
          }
        });
      }
      if(window.innerWidth >= 720 && this.swiperSlider) {
        //unwrap to simple list
        this.slider.style.display = 'none';
        this.swiperSlider.destroy(false, true);
        const slidesData =  this.slider.querySelectorAll('.js-collapsible-item');
        Array.from(slidesData).reverse().forEach((item) => {
          item.removeAttribute('style');
          this.list.prepend(item);
        });
        sliderWrapper.innerHTML = '';
        this.swiperSlider = null;
      }
    }

    this.listItems = this.root.querySelectorAll('.js-collapsible-list .js-collapsible-item');

    if(this.triggerContainer) {
      this.triggerContainer.classList.add('_hidden');

      if(window.innerWidth < 720) {
        //mobile
        if(this.isMobileSlider) {
          if(this.listItems.length) {
            this.triggerContainer.classList.remove('_hidden');
          }
        } else {
          if(this.limits.mobile < this.listItems.length) {
            this.triggerContainer.classList.remove('_hidden');
          }
        }
      } else if(window.innerWidth >= 720 && window.innerWidth < 992) {
        // tablet
        if(this.limits.tablet < this.listItems.length) {
          this.triggerContainer.classList.remove('_hidden');
        }
      } else if(window.innerWidth >= 992 && window.innerWidth < 1024) {
        // tablet wide
        if(this.limits.medium < this.listItems.length) {
          this.triggerContainer.classList.remove('_hidden');
        }
      } else if(window.innerWidth >= 1024) {
        // desktop
        if(this.limits.desktop < this.listItems.length) {
          this.triggerContainer.classList.remove('_hidden');
        }
      }
    }
  }

  _registerToggleItems() {
    this.trigger.addEventListener('click', () => {
      this.list.classList.toggle('_expanded');
      if(this.list.classList.contains('_expanded')) {
        this.trigger.innerText = this.trigger.dataset.hideText;
      } else {
        window.scrollTo({
          left: 0,
          top: window.scrollY + (this.root.getBoundingClientRect().top - this.header.getBoundingClientRect().height - 25),
          behavior: 'smooth'
        });
        this.trigger.innerText = this.trigger.dataset.showText;
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const collapsibleItems = document.querySelectorAll('.js-collapsible');
  if(collapsibleItems) {
    collapsibleItems.forEach((item) => {
      new JsCollapsible(item)
    });
  }
});